enum BeneficioFiscal {
  ZonaFrancaManaus = 1,
  ZonaFranca = 2,
  AreaLivreComercio = 3,
  AmazoniaOcidental = 4,
}

export default BeneficioFiscal;